import clsx from "clsx"
import { useEffect } from "react"
import { addZero, formatTime, fromGetDayToWeekDay, fromGetMonthToMonthName } from "../../../shared/utils/formatFunction"
import './DateMeetingCard.css'

type DateMeetingProps = {
    date: string,
    selectDate: ()=>void
    disabled?:boolean
}

export const DateMeetingCard = ( {date,disabled, selectDate}:DateMeetingProps)=>{
    const setDate = date  ? new Date(date) : new Date()
    const dayName = fromGetDayToWeekDay(setDate.getDay())
    const day = setDate.getDate()
    const month = fromGetMonthToMonthName(setDate.getMonth())
    const year = setDate.getFullYear()
    const hour = setDate.getHours()
    const minutes = setDate.getMinutes()



    return(
    <div id='dateCard' className={clsx("d-flex flex-column align-items-center me-2",
    {"card-date link-disabled": disabled},
    {"card-date-selector " : !disabled})} 
    onClick={ disabled ? ()=>{} : ()=> selectDate()}>
        <div className="d-flex flex-column align-items-center date-card-boxed  p-2">
            <p className="p-0 m-0 day-name ">{dayName}</p>
            <p className="p-0 m-0 day-number">{addZero(day)}</p>
            <p className="p-0 m-0 month">{`${month} ${year}`}</p>
        </div>
        <div className="d-flex flex-row align-items-center time-card-boxed p-1 mt-2 ">
            <p className="p-0 m-0 time">{formatTime(hour, minutes)}</p>
        </div>
    </div>
    )
}